const $ = window.jQuery;
const $window = window.$window || $(window);

const MenuToggles = {
  init() {
    var $toggles = $('[data-toggle="true"]');
    if (!$toggles.length) return;

    $toggles.each((index, toggle) => {
      this.each(toggle);
    });
  },

  each(toggle) {
    let $toggle = $(toggle);
    const toggleId = $toggle.attr("id");
    let toToggle = $('[data-toggled-by="' + toggleId + '"');

    $toggle.click(function toggle() {
      // toToggle.each((index, item) => {
      //   if (!$(item).hasClass("hidden")) {
      //     $(item).addClass("hidden");
      //   } else {
      //     $(item).removeClass("hidden");
      //   }
      // });
      toToggle.toggle();
    });
  },
};

export default MenuToggles;
